module.exports = __webpack_public_path__ + "static/media/ForgotPassword_lock.d718ef8a.svg";